export const ALL_PHASE_TAB = "all";
export const ALL_STATUS_TAB_VALUE = -1;
export const FIRST_STATUS_TAB_VALUE = 0;
export const ALL_STATUS_LABEL = "All";
export const EMPTY_STATUS_LABEL = "";
export const INVOICE_STATUS_COLUMN_WIDTH = "150px";

export const SF_INVOICE_STATUS_FIELD = "sf_invoice_status";
export const INVOICE_STATUS_FIELD = "invoice_status";
export const PHASE_STATUS_FIELD = "phase_status";
export const WAITING_FOR_ALLOCATION_PHASE_STATUS =
  "Invoice checked/waiting for allocation";
export const STATUS_FIELD = "status";

export const INVOICE_REQUEST_TYPE = {
  SLA: "sla",
  BUYER_REQUEST: "buyer_request",
} as const;

export const INVOICE_REQUEST_API_PATH = {
  SLA: "sla",
  BUYER_REQUEST: "buyer_request",
} as const;

export type InvoiceRequestType =
  (typeof INVOICE_REQUEST_TYPE)[keyof typeof INVOICE_REQUEST_TYPE];

export const INVOICE_REQUEST_ROUTE = {
  SLA: "sla",
} as const;

export const FINANCE_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
} as const;

export const PHASE_MAP = {
  PRE_LISTING: "1_PRE_LISTING",
  ON_MARKETPLACE: "2_ON_MARKETPLACE",
  IN_PROGRESS: "3_IN_PROGRESS",
  CLOSED: "4_CLOSED",
  CANCELLED: "9_CANCELLED",
} as const;

export const PHASES_WITH_ALL_STATUS = new Set<string>([
  PHASE_MAP.PRE_LISTING,
  PHASE_MAP.IN_PROGRESS,
  PHASE_MAP.CANCELLED,
]);

export const INVOICE_PHASE_TABS = [
  { value: PHASE_MAP.PRE_LISTING, label: "Pre Listing" },
  { value: PHASE_MAP.ON_MARKETPLACE, label: "On Marketplace" },
  { value: PHASE_MAP.IN_PROGRESS, label: "In Progress" },
  { value: PHASE_MAP.CLOSED, label: "Closed" },
  { value: PHASE_MAP.CANCELLED, label: "Cancelled" },
];
